import clsx from 'clsx'
import VerticalCarousel from '../vertical-carousel/VerticalCarousel'
import {operationalSupportData} from 'v1/content/marketing/free-trial'
import classes from './styles.module.css'

export default function OperationalSupport() {
  return (
    <div className={clsx(classes.bgFillSelection, classes.productSection)}>
      <VerticalCarousel
        data={operationalSupportData}
        activeBgColor={classes.bgP50}
        activeTitleTextColorClass={classes.colorP50}
        imageBgColorClass={classes.bgFillSelection}
        isTitleH3={true}
      />
    </div>
  )
}
